// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3b6Ep","rightAdornment":"Header_rightAdornment__TGj7g"};